import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Alert, Button, Card, DatePicker, Form, Popover, Select, Table, TableColumnsType, Tag, UploadFile} from "antd";
import Colors from "../../../styles/Colors";
import {BiEnvelope, BiFilter, BiMessage, BiRefresh, BiSearch} from "react-icons/bi";
import Historials from "../../components/Historials";
import {TableProps} from "antd/es/table";
import {BsEnvelope, BsPerson} from "react-icons/bs";
import dayjs, {Dayjs} from 'dayjs';
import toast, {Toaster} from "react-hot-toast";
import InscripcioFiltre from "../../../model/multilleure/casals/InscripcioFiltre";
import Activitat from "../../../model/inscripcions/Activitat";
import {GetActivitats} from "../../../dao/multilleure/GetActivitats";
import InscripcioModal from "../../inscripcions/components/InscripcioModal";
import {GetInscripcionsIdInscripcionsId} from "../../../dao/inscripcions/GetInscripcionsIdInscripcionsId";
import {GetInscripcionsActivitatIdTorn} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdTorn";
import {GetInscripcionsActivitatIdExtres} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdExtres";
import {PostInscripcioIdAlumneIdValidar} from "../../../dao/multilleure/casals/PostInscripcioIdAlumneIdValidar";
import {PostInscripcioIdValidar} from "../../../dao/multilleure/casals/PostInscripcioIdValidar";
import {GetInscripcionsActivitatsIdFiltres} from "../../../dao/multilleure/casals/GetInscripcionsActivitatsIdFiltres";
import InscripcioModalDocumentacio from "../../inscripcions/components/InscripcioModalDocumentacio";
import {GetInscripcionsIdAlumneIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdAlumneIdDocuments";
import {PostInscripcioIdError} from "../../../dao/multilleure/casals/PostInscripcioError";
import {GetLlistats} from "../../../dao/multilleure/casals/GetLlistats";
import {PostInscripcionsAlumneCasalFiltrat} from "../../../dao/multilleure/casals/PostInscripcionsAlumneCasalFiltrat";
import {PostLlistatAlumneCasalPdf} from "../../../dao/multilleure/casals/PostLlistatAlumneCasalPdf";

const EmailsCasals = () => {
    const titol: string = "EMAILS CASAL";
    const nomPermis: string = "Emails Casals";

    const {isLoggedIn, userId, user, page, token} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [idActivitat, setIdActivitat] = useState("0");

    const [showFilters, setShowFilters] = useState(false);
    const [showFiltersButton, setShowFiltersButton] = useState(false);
    const [coleccio, setDades] = useState<any[]>([])
    const [activitats, setActivitats] = useState<Activitat[]>([]);
    const [elementSelected, setElementSelected] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [selectedCasal, setSelectedCasal] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const [data, setData] = useState();
    const permisosEdicio = user.pagines.some(pagina => {
        //console.log(pagina.descripcio + " - " + pagina.tipus);
        return pagina.descripcio === nomPermis && pagina.tipus === 1
    });

    const [showDocu, setShowDocu] = useState(false);
    const [showDocuEle, setShowDocuEle] = useState<any>();
    const [docs, setDocs] = useState<UploadFile[]>([]);

    const [filtres, setFiltres] = useState<InscripcioFiltre>(new InscripcioFiltre());

    const [filtreDni, setFiltreDni] = useState([]);
    const [filtreInfant, setFiltreInfant] = useState([]);
    const [filtreUsuari, setFiltreUsuari] = useState([]);
    const [filtreEstat, setFiltreEstat] = useState([]);
    const [filtreEmail, setFiltreEmail] = useState([]);

    const [filtreCasal, setFiltreCasal] = useState<any>([]);
    const [filtreCampus, setFiltreCampus] = useState<any>([]);
    const [filtreOpcio, setFiltreOpcio] = useState<any>([]);

    const [descarregar, setDescarregar] = useState<any>(false);
    const [descarregarModal, setDescarregarModal] = useState(false);
    const [llistats, setLlistats] = useState<[]>([]);
    const [llistaActivitats, setLlistaActivitats] = useState<Activitat[]>([]);

    const [documentUrlPdf, setDocumentUrlPdf] = useState<string | undefined>("");
    const [selected, setSelected] = useState<boolean>(false);

    const [todosEmails, setTodosEmails] = useState<string>("");

    const [form] = Form.useForm();

    useEffect(() => {
        if (isLoggedIn) {
            getActivitats();
        }
    }, [id]);

    function submit() {
        //console.log("Contenido de rebutFiltre:", JSON.stringify(filtres, null, 2));
        checkDades(idActivitat);
    }

    async function togleNouElement(element: any, edit: boolean) {
        handleLoadingChange(true)

        const dad = await GetInscripcionsIdInscripcionsId(element.id_inscripcio + "", element.id_alumne_casal + "", page);
        setData(dad);
        //console.log(">>>>"+JSON.stringify(dad));

        const trn = await GetInscripcionsActivitatIdTorn(dad.id_casal, page);
        const ext = await GetInscripcionsActivitatIdExtres(dad.id_casal, page);

        setElementSelected(convertirJSON(dad, trn, ext));
        setNouElement(!nouElement);
        setEditar(edit);
        handleLoadingChange(false);
    }

    async function handleSubmit() {
        handleLoadingChange(true);
        const formData = form.getFieldsValue();

        const dad = await PostInscripcionsAlumneCasalFiltrat(formData, page);
        setDades(dad);

        if (dad) {
            const emails = dad
                .flatMap((item: any) => item.emails.map((emailObj: any) => emailObj.email))
                .filter((email: any) => email && email.trim() !== "")
                .join('; ');

            setTodosEmails(emails);
        }

        handleLoadingChange(false);
    }


    function convertirJSON(jsonSegundo: any, trn: any, ext: any): any {

        let jsonPrimero: any = {
            infant: jsonSegundo.infant,
            escola: jsonSegundo.escola,
            curs: [jsonSegundo.cicle, jsonSegundo.curs],
            id_alumne_casal: jsonSegundo.key,
            id_inscripcio: jsonSegundo.id_inscripcio,
            alergens: jsonSegundo.alergens,
            observacions: jsonSegundo.observacions,
            activitat: [jsonSegundo.id_activitat, jsonSegundo.id_casal, jsonSegundo.id_campus, jsonSegundo.id_escola_entrada],
            comentaris: jsonSegundo.comentaris
        };

        trn.forEach((element: any, index: any) => {
            const key = `setmanes-${index}`;
            const filteredData = jsonSegundo.configuracions.filter((item: any) => item.id_torn === element.id);
            const formattedSetmanes = filteredData.length > 0 ? filteredData[0].setmanes.map((fecha: string) => dayjs(fecha)) : [];
            jsonPrimero[key] = formattedSetmanes;
        });
        trn.forEach((element: any, index: any) => {
            const key = `dies-${index}`;
            const filteredData = jsonSegundo.configuracions.filter((item: any) => item.id_torn === element.id);
            const formattedSetmanes = filteredData.length > 0 ? filteredData[0].dies.map((fecha: string) => dayjs(fecha)) : [];
            jsonPrimero[key] = formattedSetmanes;
        });


        ext.forEach((element: any, index: any) => {
            const key = `extra-${index}`;
            const filteredData = jsonSegundo.extres ? jsonSegundo.extres.filter((item: any) => item.id_extra === element.id && item.value !== '') : [];
            jsonPrimero[key] = filteredData.length > 0 ? (filteredData[0].valor === 'true' ? true :
                (filteredData[0].valor === 'false' ? false : filteredData[0].valor)) : [];
        });


        //console.log("-----"+JSON.stringify(jsonPrimero));
        return jsonPrimero;
    }


    async function getActivitats() {
        const act: Activitat[] = await GetActivitats(page);
        setLlistaActivitats(act);
        const llistes = await GetLlistats(nomPermis, page);
        setLlistats(llistes);
        if (act.length === 1) {
            handleLoadingChange(true);
            setIdActivitat(act[0].id + "");
            //console.log(act[0].id);
            const newFiltres = {...filtres, activitat: act[0].id};
            setFiltres(newFiltres);
            //const dades = await PostInscripcionsAlumneCasalFiltrat(newFiltres, page);
            const fil = await GetInscripcionsActivitatsIdFiltres(token, act[0].id + "", page);
            updateFiltres(fil);
            //setDades(dades);
            //setNameFilters(dades);
            setDescarregar(true);
            handleLoadingChange(false);
        }
        setActivitats(act);
        setShowFilters(true);
        setShowFiltersButton(true);
        setSelected(true);
    }

    async function checkDades(id_activitat: string) {
        setShowFiltersButton(false);
        setShowFilters(false);
        setDescarregar(false);
        if (id_activitat !== "0") {
            handleLoadingChange(true)
            setIdActivitat(id_activitat);
            //const dades = await PostInscripcionsAlumneCasalFiltrat(filtres, page);
            //setDades(dades);
            const fil = await GetInscripcionsActivitatsIdFiltres(token, id_activitat, page);
            updateFiltres(fil);
            setDescarregar(true);
            handleLoadingChange(false);
        }
        setShowFilters(true);
        setShowFiltersButton(true);
    }

    function updateFiltres(json: any) {
        setFiltreDni(json.dnis);
        setFiltreInfant(json.infants);
        setFiltreEmail(json.email);
        setFiltreUsuari(json.usuaris);
        setFiltreEstat(json.estats);

        //console.log(permisosEdicio);
        if (permisosEdicio) {
            setFiltreCasal(json.casals);
        } else {
            //console.log(JSON.stringify(json.casals));
            const casalsFiltrats = json.casals.filter((casal: any) => casal.value !== "TOT");
            setFiltreCasal(casalsFiltrats);
            //console.log(JSON.stringify(casalsFiltrats));
        }

    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(element: any) {
        await PostInscripcioIdValidar(element.id + "", "0", page);
        await checkDades(idActivitat);
    }

    async function deleteElementAlu(element: any) {
        await PostInscripcioIdAlumneIdValidar(element.id_inscripcio + "", element.id_alumne_casal + "", "0", page);
        await checkDades(idActivitat);
    }

    function afegirElement(element: any) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: any[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ingredientNames);
    }

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    async function validar(element: any) {
        await PostInscripcioIdValidar(element.id + "", "2", page);
        await checkDades(idActivitat);
    }

    function editarInscripcio(ele: any) {
        navigate(`/inscripcions/gestio/${ele.id}`);
        //window.open(`/inscripcions/gestio/${ele.id}`, "_blank");
    }

    function tickets(ele: any) {
        navigate(`/artsiesports/rebuts/${ele.nomContacte}`);
    }

    async function informarError(ele: any) {
        await PostInscripcioIdError(ele.id + "", page);
        await checkDades(idActivitat);
    }

    /**
     * --- FILTRES ----
     **/

    const tableProps: TableProps<any> = {
        loading
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    const {RangePicker} = DatePicker;

    function changeActivitat(id_activitat: string) {
        setIdActivitat(id_activitat);
        setSelected(true);
        checkDades(id_activitat);
    }

    function validarAlumne(ele: any) {

    }

    async function togleNouElementDocument(ele: any, b: boolean) {
        const dds3 = await GetInscripcionsIdAlumneIdDocuments(ele.id + "", ele.id_alumne_casal + "", page);
        setDocs(dds3.fileList);
        setShowDocuEle(ele);
        setShowDocu(true);
    }

    const colorsArray = [Colors.colors.color1, Colors.colors.color2, Colors.colors.color4, Colors.colors.color5, Colors.colors.color6];

    function enviar(emails: any) {
        //console.log(JSON.stringify(emails));
        const emailAddresses = emails.map((emailObj: any) => emailObj.email).join('; ');
        const mailtoLink = `mailto:${emailAddresses}`;
        //console.log(">>>>>"+mailtoLink);
        window.location.href = mailtoLink;
    }

    const columns: TableColumnsType<any> = [
        {
            key: 'key',
            title: 'ID',
            dataIndex: 'key',
            width: 30
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            render: (infant, ele) => (
                <Popover content={(
                    <div>
                        <p>{ele.comentaris}</p>
                        <p>{ele.observacions}</p>
                    </div>
                )}
                         title="Comentaris" trigger="click">
                    <Tag key={ele.key}
                         color={ele.comentaris !== '' || ele.observacions !== '' ? Colors.colors.color1 : Colors.colors.color5}>
                        {ele.nom}&nbsp;{(ele.comentaris !== '' || ele.observacions !== '') && <BiMessage/>}
                    </Tag>
                </Popover>
            )
        },
        {
            key: 'casal',
            title: 'Casal',
            dataIndex: 'casal',
            width: 100,
        },
        {
            key: 'campus',
            title: 'Campus',
            dataIndex: 'campus',
            width: 30,
        },
        {
            key: 'curs',
            title: 'Curs',
            dataIndex: 'curs',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={Colors.colors.color3} key={ele.key}>{ele.cicle}</Tag>
                    <Tag color={Colors.colors.color4} key={ele.key}>{ele.curs}</Tag>
                </>
            )
        },
        {
            key: 'correu',
            title: 'Correus',
            dataIndex: 'correu',
            width: 30,
            render: (estat, ele) => (
                <>
                    {ele.emails?.map((e: any) =>
                        <Popover content={(
                            <div>
                                <p>{e.nom}</p>
                            </div>
                        )}
                                 title="Nom del contacte" trigger="click">
                            <Tag color={Colors.colors.color2} key={e.email}>{e.email}&nbsp;<BsPerson/></Tag><br/>
                        </Popover>
                    )}
                </>
            )
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 150,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Enviar Correu"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => enviar(ele.emails)}><BsEnvelope/></Button>
                        </>
                    )}
                </>
            )
        }
    ];


    function handleCloseModalDocu() {
        setShowDocu(false);
    }

    const setmanes = [
        {value: "0", label: "TOTES"},
        {value: "1", label: "Setmana-1"},
        {value: "2", label: "Setmana-2"},
        {value: "3", label: "Setmana-3"},
        {value: "4", label: "Setmana-4"},
        {value: "5", label: "Setmana-5"},
        {value: "6", label: "Setmana-6"},
    ];

    function changeCasal(element: any) {
        const selectedCasal = filtreCasal.find((casal: any) => casal.value === element);

        setFiltreCampus(selectedCasal.campus);
        setFiltreOpcio(selectedCasal.opcions);
        const newFiltres = {...filtres, idCampus: 0, idOpcio: 0}
        setFiltres(newFiltres);
        setSelectedCasal(true);
    }


    function clear() {
        setFiltreCampus([]);
        setFiltreCasal([]);
        setFiltreOpcio([]);
    }

    async function download() {

        const formData = form.getFieldsValue();
        //console.log("Form Data:", formData);
        //console.log(JSON.stringify(formData));

        const documentUrl = await PostLlistatAlumneCasalPdf(formData, page);
        setDocumentUrlPdf(documentUrl);

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `Llistat.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    function emailConjunt() {
        //console.log(JSON.stringify(emails));
        const mailtoLink = `mailto:${todosEmails}`;
        //console.log(">>>>>"+mailtoLink);
        window.location.href = mailtoLink;
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades(idActivitat)}><BiRefresh/></Button>
                            <Button title={"Mostrar filtres"} style={{backgroundColor: Colors.colors.color5}}
                                    disabled={!showFiltersButton}
                                    onClick={() =>
                                        setShowFilters(!showFilters)}><BiFilter/></Button>
                        </div>
                        {showFilters && (
                            <>
                                <br/>
                                <br/>
                                <br/>
                                <Form form={form} initialValues={filtres} onFinish={handleSubmit}>
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="activitat"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={activitats.length === 0}
                                                    placeholder="Selecciona Activitat"
                                                    optionFilterProp="children"
                                                    onChange={changeActivitat}
                                                    options={activitats}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idCasal"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCasal?.length < 0 || !selected}
                                                    placeholder="Selecciona Casal"
                                                    optionFilterProp="children"
                                                    onChange={changeCasal}
                                                    options={filtreCasal}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idCampus"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCampus.length < 0 || !selected || !selectedCasal}
                                                    placeholder="Selecciona Campus"
                                                    optionFilterProp="children"
                                                    options={filtreCampus}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idOpcio"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreOpcio.length < 0 || !selected || !selectedCasal}
                                                    placeholder="Selecciona Opció"
                                                    optionFilterProp="children"
                                                    options={filtreOpcio}
                                            />
                                        </Form.Item>
                                        <br/>
                                        <br/>
                                        <Form.Item
                                            name="setmana"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCasal.length < 0 || !selected || !selectedCasal}
                                                    placeholder="Selecciona Setmana"
                                                    optionFilterProp="children"
                                                    options={setmanes}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}>
                                            <Button title={"Buscar"} htmlType={"submit"} disabled={!selectedCasal}
                                                    style={{backgroundColor: Colors.colors.color6}}><BiSearch/></Button>
                                            {" "}
                                            <Button title={"Enviar Correu Conjunt"} onClick={emailConjunt}
                                                    disabled={todosEmails === ''}
                                                    style={{backgroundColor: Colors.colors.color4}}><BiEnvelope/></Button>
                                        </Form.Item>
                                        <Form.Item
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}>
                                        </Form.Item>
                                    </Form.Item>
                                </Form>
                                <br/>
                            </>
                        )}
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <>
                                <p>Número d'alumnes: <b>{coleccio ? coleccio.length : 0}</b></p>
                                <Alert type={"info"}
                                       message={"Pots veure el nom del contacte fent 'click' a sobre del correu!"}/>
                                <Table
                                    {...tableProps}
                                    columns={columns}
                                    dataSource={coleccio}
                                />
                                <br/>
                                <Card>
                                    {todosEmails}
                                </Card>
                            </>
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"PLANTILLA"} pagina={page}/>
                    {nouElement && (
                        <InscripcioModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                         page={page} edit={true}/>
                    )}
                    {showDocu && (
                        <InscripcioModalDocumentacio idInsc={showDocuEle.id_inscripcio} element={showDocuEle}
                                                     visible={showDocu} page={page} onClose={handleCloseModalDocu}
                                                     documents={docs}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default EmailsCasals;
